// extracted by css-extract-rspack-plugin
var _1 = "EQECjE93dwc0bFDj";
export { _1 as "flagIcon" }
// extracted by css-extract-rspack-plugin
var _1 = "EQECjE93dwc0bFDj";
export { _1 as "flagIcon" }
